import React, { Component } from "react";

class Section1AcademyMobile extends Component {
  render() {
    return (
      <div
        id="section1Academy"
        className="section content_container"
        style={{
          width: this.props.wd.ww,
          height: this.props.wd.sh / 2,
        }}
      >
        <img
          alt="Imagem do título"
          className="title"
          src="images/section1academy_title_mobile.png"
        />
        <div className="column left"></div>
        <div className="column right"></div>
      </div>
    );
  }
}

export default Section1AcademyMobile;
